<template>
  <div>
    <v-container grid-list-xl fluid>
      <table-withdrawal></table-withdrawal>
    </v-container>
  </div>
</template>

<script>
import TableWithdrawal from "@/components/table/TableWithdrawal";
export default {
  name: "Withdrawals",
  components: {
    TableWithdrawal
  }
};
</script>

<style scoped></style>
